module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDeelnemenE2A637.9a923b83.png";